import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type VariantSelectorBaseClasses = 'container' | 'accordionSummary';

const variantSelectorBaseStyles = makeStyles<ISpcTheme, VariantSelectorBaseClasses>(
  () => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    accordionSummary: {
      padding: '0 0 5px 0',
    },
  }),
  { name: 'Common_VariantSelector' },
);

export default variantSelectorBaseStyles;
